import * as React from "react";
import { useCallback, useMemo, useRef } from "react";
import { Formik, Form, Field } from "formik";
import styled from "styled-components";
import { Trans, useTranslation } from "react-i18next";
import Button from "components/bootstrap/Button";
import IconButton from "components/common/IconButton";
import ButtonGroup from "components/bootstrap/ButtonGroup";
import ClipboardIconButton from "components/common/ClipboardIconButton";
import useSendTelemetry from "logic/telemetry/useSendTelemetry";
import { TELEMETRY_EVENT_TYPE } from "telemetry/Constants";
import UserNotification from "util/UserNotification";
import OverlayTrigger from "components/common/OverlayTrigger";
import { Input } from "components/bootstrap";
const Actions = styled(ButtonGroup)`
  margin-top: 10px;
`;
const ResponseRating = () => {
  const { t } = useTranslation("enterprise_ai");
  const overlay = useRef();
  const sendTelemetry = useSendTelemetry();
  const onRating = useCallback(
    (values) => {
      sendTelemetry(TELEMETRY_EVENT_TYPE.WIDGET_SUMMARY.USER_SURVEY, {
        app_value: values
      });
      UserNotification.success(t("response_rating.thanks"));
    },
    [sendTelemetry, t]
  );
  const onGoodRating = useCallback(() => onRating({ rating: 3 }), [onRating]);
  const onBadRating = useCallback(
    (rating) => {
      onRating(rating);
      overlay.current.hide();
    },
    [onRating]
  );
  const badRatingOverlay = useMemo(
    () => /* @__PURE__ */ React.createElement(Formik, { onSubmit: onBadRating, initialValues: { rating: 1, review: void 0 } }, /* @__PURE__ */ React.createElement(Form, null, /* @__PURE__ */ React.createElement(Field, { name: "review" }, ({ field: { name, value, onChange } }) => /* @__PURE__ */ React.createElement(
      Input,
      {
        id: name,
        name,
        type: "textarea",
        value,
        onChange,
        label: /* @__PURE__ */ React.createElement("span", null, /* @__PURE__ */ React.createElement(
          Trans,
          {
            t,
            i18nKey: "response_rating.review_label",
            components: { optional: /* @__PURE__ */ React.createElement("small", { className: "text-muted" }) }
          }
        )),
        rows: 4
      }
    )), /* @__PURE__ */ React.createElement(Button, { bsSize: "xs", type: "submit" }, t("common:actions.submit")))),
    [onBadRating, t]
  );
  return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(
    IconButton,
    {
      name: "thumb_up",
      iconType: "regular",
      size: "xs",
      title: t("response_rating.good_title"),
      onClick: onGoodRating
    }
  ), /* @__PURE__ */ React.createElement(OverlayTrigger, { ref: overlay, overlay: badRatingOverlay, placement: "bottom", trigger: "click", rootClose: true }, /* @__PURE__ */ React.createElement(IconButton, { name: "thumb_down", iconType: "regular", size: "xs", title: t("response_rating.bad_title") })));
};
const ResponseActions = ({ response }) => {
  const { t } = useTranslation("enterprise_ai");
  return /* @__PURE__ */ React.createElement(Actions, null, /* @__PURE__ */ React.createElement(ResponseRating, null), /* @__PURE__ */ React.createElement(ClipboardIconButton, { text: response.text, buttonTitle: t("response_actions.copy_title") }));
};
export default ResponseActions;
